interface IExpressionTransformMapping {
    subject: string
    mappings: ITransformMapping[]
}

interface ITransformMapping {
    source: string
    destination: string
}

interface IMutableExpressionTransformMapping {
    subject: KnockoutObservable<string>
    mappings: KnockoutObservableArray<IMutableTransformMapping>
}

interface IMutableTransformMapping {
    source: KnockoutObservable<string>
    destination: KnockoutObservable<string>
}
